import React from 'react';
import classnames from 'classnames';

import Image from 'components/Image';

import ExpandableList from './ExpandableList';
import ExpansionToggle from './ExpansionToggle';
import { IQuality } from 'types/qualities';
import { ITooltipData } from 'components/ModalTooltip/types';

interface Props extends Pick<IQuality, 'description' | 'id' | 'image' | 'name' | 'nameAndLevel' | 'relationshipDescription'> {
  expanded: boolean,
  onToggleExpanded: () => void,
  tooltipData: ITooltipData,
}

export default function QualityItemComponent(props: Props) {
  const {
    description,
    expanded,
    id,
    image,
    name,
    nameAndLevel,
    onToggleExpanded,
    relationshipDescription,
    tooltipData,
  } = props;

  return (
    <li className="quality-item">
      <div
        className="icon icon--circular quality-item__icon"
        data-branch-id={id}
      >
        <Image
          defaultCursor
          className="media__object"
          icon={image}
          alt={name}
          type="small-icon"
          tooltipData={tooltipData}
          tooltipPos="right"
        />
      </div>
      <div className="quality-item__body">
        <span
          className={classnames(
            'js-item-name item__name quality-item__name',
            !!relationshipDescription && 'item__name--has-expansion',
          )}
        >
          {nameAndLevel}
          {relationshipDescription && (
            <ExpansionToggle
              expanded={expanded}
              onClick={onToggleExpanded}
            />
          )}

        </span>
        <p className="quality-item__description" dangerouslySetInnerHTML={{ __html: description }} />
        {relationshipDescription && (
          <ExpandableList
            content={relationshipDescription}
            expanded={expanded}
          />
        )}
      </div>
    </li>
  );
}
